import { EdTabsHeaderOption } from '@/models/ed-tabs-header-option.model';
import { BOOKSTORE_ROUTES } from '../bookstore.router';

export const BOOKSTORE_MENU: EdTabsHeaderOption[] = [{
  id: 1,
  active: true,
  path: BOOKSTORE_ROUTES.TEMPLATES.NAME,
  name: 'templates',
  label: 'Templates',
  disabled: false,
}];